/* eslint-disable */
/*
 * ----------------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API-ES            ##
 * ## SOURCE: https://github.com/hunghg255/swagger-typescript-api-es   ##
 * ----------------------------------------------------------------------
 */

export interface ApiConfirmEmailResult {
  redirectUri?: string | null;
}

export interface ApiEmailChange {
  /**
   * Новая почта
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface ApiForgotPassword {
  /**
   * @format email
   * @minLength 1
   */
  email: string;
}

export interface ApiLoginEdsPayload {
  /**
   * base64 строка данных. значение типа unix-время UTC (long секунды) в виде строки (https://www.unixtimestamp.com/)
   * сконвертировать строчку с unix-временем "1659475780"
   * const byteArr = utf8Encode.encode("1659475780");
   * подписать byteArr и в Data передать base64 от byteArr
   * @minLength 1
   */
  data: string;
  /**
   * base64 detached pkcs7 подпись строки с unix-временем в ASCII кодировке
   * @minLength 1
   */
  signature: string;
}

export interface ApiLoginPayload {
  /** @minLength 1 */
  login: string;
  /** @minLength 1 */
  password: string;
}

export interface ApiLoginResult {
  /** Список профилей пользователя */
  profiles?: ApiProfile[] | null;
  /** Урл на который необходимо отправить запрос после выбора профиля пользователем */
  redirectUri?: string | null;
}

export interface ApiProfile {
  /** @format uuid */
  id: string;
  title?: string | null;
  /** Требуется подтверждение с помощью ЭЦП */
  isSignatureRequired: boolean;
}

export interface ApiProfilePhoneChange {
  /**
   * Новый телефон
   * @minLength 1
   */
  phone: string;
}

export interface ApiProfilePhoneConfirmationRequired {
  /**
   * Id профиля
   * @format uuid
   */
  profileId: string;
}

export interface ApiResetPassword {
  /** @minLength 1 */
  password: string;
}

export interface ApiSignInWithProfilePayload {
  /**
   * Id профиля
   * @format uuid
   */
  profileId: string;
  signedPayload?: ApiSignedProfilePayload;
}

export interface ApiSignInWithProfileResult {
  redirectUri?: string | null;
}

export interface ApiSignedProfilePayload {
  /**
   * base64 строка SignedProfile
   * @minLength 1
   */
  data: string;
  /**
   * base64 detached pkcs7 подпись строки SignedProfile
   * @minLength 1
   */
  signature: string;
}

export interface ApiUserInfoResult {
  sub: string | null;
  account: ApiAccount;
  profile?: ApiProfileBase;
  isTemporaryPassword: boolean;
  /**
   * Срок действия пароля
   * @format date-time
   */
  passwordExpiresAt?: string;
}

export interface ApiRequest {
  /**
   * @minLength 6
   * @maxLength 6
   */
  code: string;
}

export interface ApiRequest {
  /** @minLength 1 */
  code: string;
}

export interface ApiRequest {
  /**
   * @format uuid
   * @minLength 1
   */
  userId: string;
  /** @minLength 1 */
  code: string;
  payload: ApiResetPassword;
}

export interface ApiProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface ApiValidationProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  errors?: Record<string, string[]>;
  [key: string]: any;
}

export interface ApiAccount {
  login?: string | null;
  email?: string | null;
  isActive: boolean;
  isEmailConfirmed: boolean;
}

export interface ApiProfileBase {
  /** @format uuid */
  accountId?: string | null;
  isSignatureRequired: boolean;
  isActive: boolean;
  type: ApiProfileType;
  title?: string | null;
  email?: string | null;
  phone?: string | null;
  isPhoneConfirmed: boolean;
}

/** @format int32 */
export enum ApiProfileType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from 'axios';
import axios from 'axios';

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, 'data' | 'params' | 'url' | 'responseType'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, 'data' | 'cancelToken'> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;

  abortService?: {
    getSignal(): AbortSignal;
  };
  instance?: AxiosInstance;
  injectHeaders?: (data: any) => any;
}

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private secure?: boolean;
  private format?: ResponseType;
  private injectHeaders?: (data: any) => any;
  private abortService: {
    getSignal(): AbortSignal;
  };

  constructor({
    securityWorker,
    secure,
    format,
    instance,
    injectHeaders,
    abortService,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance =
      instance ?? axios.create({ ...axiosConfig, baseURL: axiosConfig.baseURL || '' });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
    this.injectHeaders = injectHeaders;
    this.abortService = abortService!;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[method.toLowerCase() as keyof HeadersDefaults]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === 'object' && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] = property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T, _E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (type === ContentType.FormData && body && body !== null && typeof body === 'object') {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (type === ContentType.Text && body && body !== null && typeof body !== 'string') {
      body = JSON.stringify(body);
    }

    let headers = {
      ...(requestParams.headers || {}),
      ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
    };

    if (this.injectHeaders) {
      headers = await this.injectHeaders(headers);
    }

    return this.instance.request({
      ...requestParams,
      headers,
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
      signal: this.abortService.getSignal(),
    });
  };
}

/**
 * @title RMP Authentication Api
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  connect = {
    /**
     * No description
     *
     * @tags Authentication
     * @name AuthorizeList
     * @summary Получить авторизационный код
     * @request GET:/connect/authorize
     */
    authorizeList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/connect/authorize`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name TokenCreate
     * @summary Получить токен по авторизационному коду
     * @request POST:/connect/token
     */
    tokenCreate: (params: RequestParams = {}) =>
      this.request<void, ApiProblemDetails>({
        path: `/connect/token`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name SignInWithProfileCreate
     * @summary Аутентификация по профилю
     * @request POST:/connect/sign-in-with-profile
     */
    signInWithProfileCreate: (data: ApiSignInWithProfilePayload, params: RequestParams = {}) =>
      this.request<
        ApiSignInWithProfileResult,
        void | ApiValidationProblemDetails | ApiProblemDetails
      >({
        path: `/connect/sign-in-with-profile`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name LogoutList
     * @summary Закрыть сессию
     * @request GET:/connect/logout
     */
    logoutList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/connect/logout`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name LogoutCreate
     * @summary Закрыть сессию
     * @request POST:/connect/logout
     */
    logoutCreate: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/connect/logout`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name UserinfoList
     * @summary Получить информацию о пользователе
     * @request GET:/connect/userinfo
     */
    userinfoList: (params: RequestParams = {}) =>
      this.request<ApiUserInfoResult, ApiProblemDetails>({
        path: `/connect/userinfo`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name UserinfoCreate
     * @summary Получить информацию о пользователе
     * @request POST:/connect/userinfo
     */
    userinfoCreate: (params: RequestParams = {}) =>
      this.request<ApiUserInfoResult, ApiProblemDetails>({
        path: `/connect/userinfo`,
        method: 'POST',
        format: 'json',
        ...params,
      }),
  };
  auth = {
    /**
     * No description
     *
     * @tags Authentication
     * @name LoginCreate
     * @summary Аутентифицировать пользователя по логину и паролю
     * @request POST:/auth/login
     */
    loginCreate: (data: ApiLoginPayload, params: RequestParams = {}) =>
      this.request<ApiLoginResult, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name CertificateLoginCreate
     * @summary Аутентифицировать пользователя по ЭЦП
     * @request POST:/auth/certificate/login
     */
    certificateLoginCreate: (data: ApiLoginEdsPayload, params: RequestParams = {}) =>
      this.request<ApiLoginResult, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/certificate/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ConfirmEmailListByCode
     * @summary Подтверждение почты
     * @request GET:/auth/confirm-email
     */
    confirmEmailListByCode: (
      query: {
        /**
         * @minLength 6
         * @maxLength 6
         */
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<ApiConfirmEmailResult, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/confirm-email`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name RequestCodeCreate
     * @summary Запросить новый код подтверждения
     * @request POST:/auth/request-code
     */
    requestCodeCreate: (params: RequestParams = {}) =>
      this.request<void, ApiProblemDetails>({
        path: `/auth/request-code`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ResetPasswordCreateByUserId
     * @summary Сброс пароля
     * @request POST:/auth/reset-password
     */
    resetPasswordCreateByUserId: (
      query: {
        /**
         * @format uuid
         * @minLength 1
         */
        userId: string;
        /** @minLength 1 */
        code: string;
      },
      data: ApiResetPassword,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/reset-password`,
        method: 'POST',
        query: query,
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name PasswordCreate
     * @summary Установление пароля
     * @request POST:/auth/password
     */
    passwordCreate: (data: ApiResetPassword, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ForgotPasswordCreate
     * @summary Генерирует новый код, который будет отправлен на указанную почту (только для обычного аккаунта, не МА)
     * @request POST:/auth/forgot-password
     */
    forgotPasswordCreate: (data: ApiForgotPassword, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/forgot-password`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ChangeEmailCreate
     * @summary Изменение Email пользователя
     * @request POST:/auth/change-email
     */
    changeEmailCreate: (data: ApiEmailChange, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/change-email`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name RequestProfilePhoneConfirmationCodeCreate
     * @summary Запросить новый код подтверждения телефона
     * @request POST:/auth/request-profile-phone-confirmation-code
     */
    requestProfilePhoneConfirmationCodeCreate: (params: RequestParams = {}) =>
      this.request<void, ApiProblemDetails>({
        path: `/auth/request-profile-phone-confirmation-code`,
        method: 'POST',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ChangeProfilePhoneCreate
     * @summary Изменение Телефона текущего профиля пользователя
     * @request POST:/auth/change-profile-phone
     */
    changeProfilePhoneCreate: (data: ApiProfilePhoneChange, params: RequestParams = {}) =>
      this.request<void, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/change-profile-phone`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ConfirmProfilePhoneListByCode
     * @summary Подтверждение телефона профиля
     * @request GET:/auth/confirm-profile-phone
     */
    confirmProfilePhoneListByCode: (
      query: {
        /** @minLength 1 */
        code: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/confirm-profile-phone`,
        method: 'GET',
        query: query,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name ProfilePhoneConfirmationRequiredCreate
     * @summary Выставить признак необходимости подтверждения телефона профиля
     * @request POST:/auth/profile-phone-confirmation-required
     */
    profilePhoneConfirmationRequiredCreate: (
      data: ApiProfilePhoneConfirmationRequired,
      params: RequestParams = {},
    ) =>
      this.request<void, ApiValidationProblemDetails | ApiProblemDetails>({
        path: `/auth/profile-phone-confirmation-required`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),
  };
}
